import type { ConfigRouteParamsRequest } from '@pba/react-utils';
import type { AxiosResponse } from 'axios';
import { getApiAxiosInstance } from '#client';
import type { CommunityDetailDataObject } from '#models/services';
import { routes } from '../routes';

type GetCommunityPathParams = {
  id: string;
};

type GetCommunityQueryParams = {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Keys are defined by Backend API endpoint
  invitation_token?: string;
};

export const getCommunity = async ({
  config: { params },
  routeParams: { id },
}: ConfigRouteParamsRequest<GetCommunityQueryParams, GetCommunityPathParams>) =>
  getApiAxiosInstance().get<CommunityDetailDataObject, AxiosResponse<CommunityDetailDataObject>>(
    routes.communities.get(id),
    { params },
  );
